module.exports = __webpack_public_path__ + "6754e781061ee7c2cb51b3507b1e4d14.svg";